/* ============================================================
   LAYAM STORE — bespoke interactions for the custom design layer.
   Dependency-free. Enhances markup rendered by the layam-* sections;
   everything degrades gracefully if this file never loads.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Hero slideshow ---------- */
  function initHero(root) {
    var slides = root.querySelectorAll('[data-la-hero-slide]');
    var panels = root.querySelectorAll('[data-la-hero-panel]');
    var dots = root.querySelectorAll('[data-la-hero-dot]');
    if (slides.length < 2) return;

    var i = 0, timer = null;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      panels.forEach(function (p, k) {
        var on = k === i;
        p.style.display = on ? '' : 'none';
        if (on) { p.style.animation = 'none'; void p.offsetWidth; p.style.animation = 'layamRise 0.7s ease both'; }
      });
      dots.forEach(function (d, k) {
        var on = k === i;
        d.setAttribute('aria-current', on ? 'true' : 'false');
        d.style.width = on ? '26px' : '10px';
        d.style.background = on ? 'var(--color-accent-400)' : 'color-mix(in srgb, #f9f4ed 45%, transparent)';
      });
    }
    function next() { show(i + 1); }
    function start() { if (!reduce) { stop(); timer = setInterval(next, 5000); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { show(k); start(); });
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    show(0);
    start();
  }

  /* ---------- Product card quick-add ---------- */
  function money(cents, fmt) {
    var n = (cents / 100);
    // Rupee, no decimals — matches the store's INR formatting.
    return 'Rs. ' + Math.round(n).toLocaleString('en-IN');
  }

  function initCard(card) {
    var sizes = card.querySelectorAll('[data-la-size]');
    var priceEl = card.querySelector('[data-la-price]');
    var addBtn = card.querySelector('[data-la-add]');
    var state = { id: card.getAttribute('data-default-variant'), price: priceEl ? priceEl.textContent : '' };

    sizes.forEach(function (btn) {
      btn.addEventListener('click', function () {
        sizes.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        state.id = btn.getAttribute('data-variant-id');
        var p = btn.getAttribute('data-variant-price');
        if (priceEl && p) priceEl.textContent = p;
      });
    });

    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (!state.id) return;
        addToCart(state.id, 1, addBtn);
      });
    }
  }

  function addToCart(variantId, qty, btn) {
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    var routes = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(routes + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: qty }],
        sections: 'cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { throw new Error(data.description || 'Could not add'); }
        var title = (data.items && data.items[0] && data.items[0].product_title) ||
                    (data.product_title) || 'Item';
        var variant = (data.items && data.items[0] && data.items[0].variant_title) ||
                      (data.variant_title) || '';
        updateBubble(data.sections && data.sections['cart-icon-bubble']);
        toast((variant ? title + ' ' + variant : title) + ' added', true);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function (err) { toast(String(err.message || 'Could not add to cart')); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  }

  function updateBubble(html) {
    if (!html) return;
    var current = document.getElementById('cart-icon-bubble');
    if (!current) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('#cart-icon-bubble') || tmp;
    current.innerHTML = fresh.innerHTML;
  }

  // Other scripts (layam-shop.js quick-add) request the same toast by event,
  // so there is exactly one notification style everywhere.
  document.addEventListener('la:toast', function (e) {
    toast((e.detail && e.detail.msg) || 'Added to basket', true);
  });

  /* Free-delivery nudge: the threshold the shipping zones enforce (Rs 499).
     Shown only on successful adds -- an error toast gets no upsell. */
  var FREE_SHIP_PAISE = 49900;
  function freeShipLine(el) {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var line = document.createElement('span');
      line.style.cssText = 'flex-basis:100%;text-align:center;font-size:13px;color:#d8cfc0';
      var rem = FREE_SHIP_PAISE - c.total_price;
      line.textContent = rem <= 0
        ? 'Free delivery unlocked ✓'
        : 'Add ₹' + Math.ceil(rem / 100).toLocaleString('en-IN') + ' more for free delivery';
      el.appendChild(line);
    }).catch(function () { /* nudge is a bonus; never block the toast */ });
  }

  var toastTimer = null;
  function toast(msg, withShipHint) {
    // Pages with the persistent cart bar get ONE bottom element: successful
    // adds are announced inside the bar itself. The toast remains only for
    // errors, and for templates where the bar is suppressed.
    if (withShipHint && document.querySelector('[data-la-cartbar]') &&
        window.matchMedia('(max-width: 749px)').matches) {
      document.dispatchEvent(new CustomEvent('la:cartbar:flash', { detail: { msg: msg } }));
      return;
    }
    var existing = document.querySelector('.la-store-toast');
    if (existing) existing.remove();
    var el = document.createElement('div');
    el.className = 'la-store-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    el.innerHTML =
      '<span style="width:26px;height:26px;border-radius:999px;background:#e28c62;display:grid;place-items:center">' +
      '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#4d1f11" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span>' +
      '<span style="font-size:14px">' + msg + '</span>' +
      '<a href="' + cartUrl + '" style="font-size:13px;padding:6px 14px;border-radius:999px;background:color-mix(in srgb,#f9f4ed 16%,transparent);color:#f9f4ed;text-decoration:none;white-space:nowrap">View basket</a>';
    document.body.appendChild(el);
    if (withShipHint) freeShipLine(el);
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.remove(); }, withShipHint ? 4200 : 3200);
  }

  function boot() {
    document.querySelectorAll('[data-la-hero]').forEach(initHero);
    document.querySelectorAll('[data-la-card]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-init in the theme editor when sections reload.
  document.addEventListener('shopify:section:load', boot);
})();

/* ---------- Cart pulse ----------
   Any add-to-cart path ends with the #cart-icon-bubble section being
   re-rendered (Dawn's cart-notification on product pages, our quick-add's
   updateBubble on cards). Watching that node means every path gets the
   same "look at the cart" pulse without wiring each one individually. */
(function () {
  var cart = document.getElementById('cart-icon-bubble');
  if (!cart || !('MutationObserver' in window)) return;
  var t = null;
  new MutationObserver(function () {
    cart.classList.remove('la-cart-ping');
    void cart.offsetWidth; /* restart the animation on rapid re-adds */
    cart.classList.add('la-cart-ping');
    clearTimeout(t);
    t = setTimeout(function () { cart.classList.remove('la-cart-ping'); }, 2000);
  }).observe(cart, { childList: true, subtree: true });
})();
